import React, { useCallback, useContext } from "react";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import { IAssemblyAttendances } from "src/stores/assemblies/AttendanceListStore";
import { formatCurrency } from "src/utils/Currency";

const AttendanceListRowDesktopBase = (props: {
    attendances: IAssemblyAttendances;
    widths: number[];
    showTenantName: boolean;
}) => {
    const { attendanceListStore } = useContext(RootStoreContext);
    const { attendancestate, tenantname, unitname, value, tenantid } = props.attendances;
    const { widths, showTenantName } = props;

    const attendanceLabel =
        attendanceListStore.attendanceStates.find((state) => state.key === attendancestate)?.label || "Unknown";

    const onSelectDropdown = useCallback(
        (stateId: string) => {
            attendanceListStore.updateAttendanceState(tenantid, stateId);
        },
        [tenantid, attendanceListStore]
    );

    return (
        <UI.List.Row>
            <UI.List.Cell value={showTenantName ? tenantname : ""} colspan={widths[0]} />
            <UI.List.Cell colspan={widths[1]} value={formatCurrency(Number(value))} />
            <UI.List.Cell value={unitname} colspan={widths[2]} />
            <UI.List.Cell
                colspan={widths[3]}
                value={
                    showTenantName ? (
                        <UI.Dropdown
                            id="sort"
                            onSelect={onSelectDropdown}
                            items={attendanceListStore.attendanceStates.map((item) => ({
                                label: item.label,
                                value: item.id
                            }))}
                            label={
                                attendanceListStore.attendanceStates.find((item) => item.label === attendanceLabel)
                                    ?.label ?? ""
                            }
                            className="mb-0"
                        />
                    ) : (
                        ""
                    )
                }
            />
        </UI.List.Row>
    );
};

export const AttendanceListRowDesktop = Sentry.withProfiler(observer(AttendanceListRowDesktopBase));
